import { User } from "../../types/user";
import { generateAPI } from "../api.generator";

export const getUserByParams = generateAPI<
  {
    params: string,
  }, 
  User
  >("get", "user");
